<template>
  <div>
    <v-progress-linear
      color="accent"
      indeterminate
      v-if="taskLoader"
    ></v-progress-linear>
    <task-card
      v-if="task && task.id"
      :task-id="task.id"
      task-view="claimed"
      :task-action="true"
      :selected-task-id="task.id"
      :key="task.id + 'task-card'"
    />
  </div>
</template>

<script>
import TaskCard from './TaskCard'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'TaskApprovalCard',
  components: { TaskCard },
  data() {
    return {
      taskLoader: false
    }
  },
  mounted() {
    this.getSelectedFromRoute()
  },
  methods: {
    async getSelectedFromRoute() {
      if (this.$router.currentRoute.name === 'task-action') {
        await this.getSelectedTaskDetails(this.$route.params.hexId)
      } else {
        this.$router.push({ name: 'tasks' }).catch()
      }
    },
    async getSelectedTaskDetails(taskId) {
      this.taskLoader = true
      try {
        await this.$store.dispatch('fetchTask', taskId)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to fetch the Task, Re-directing to Task List',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.$router.replace({ name: 'tasks' }).catch()
      }
      this.taskLoader = false
    }
  },
  computed: {
    ...mapState({
      task: state => state.tasks.selectedTaskForApproval,
      user: state => state.session.user
    }),
    ...mapGetters({
      can: 'can'
    })
  }
}
</script>

<style scoped></style>
